var React = require('react');

function OptimizeBid (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM7.94688 2.71899C8.17722 2.3916 8.69207 2.55457 8.69207 2.95486V6.46961H12.0556C12.3877 6.46961 12.5819 6.84381 12.3909 7.11541L8.05301 13.281C7.82268 13.6084 7.30782 13.4454 7.30782 13.0451V9.53039H3.9443C3.61221 9.53039 3.41795 9.15619 3.60904 8.88459L7.94688 2.71899Z","fill":"#6366F1"}));
}

OptimizeBid.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = OptimizeBid;

OptimizeBid.default = OptimizeBid;
